import React from "react";

function SynthesisIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 21 21">
      <g
        id="Groupe_2664"
        data-name="Groupe 2664"
        transform="translate(24464 23842)"
      >
        <g
          id="Rectangle_870"
          data-name="Rectangle 870"
          transform="translate(-24464 -23842)"
        >
          <rect width="10" height="9" rx="2" stroke="none" />
          <rect
            x="0.25"
            y="0.25"
            width="9.5"
            height="8.5"
            rx="1.75"
            fill="none"
          />
        </g>
        <g
          id="Rectangle_871"
          data-name="Rectangle 871"
          transform="translate(-24464 -23832)"
        >
          <rect width="10" height="11" rx="2" stroke="none" />
          <rect
            x="0.25"
            y="0.25"
            width="9.5"
            height="10.5"
            rx="1.75"
            fill="none"
          />
        </g>
        <g
          id="Rectangle_872"
          data-name="Rectangle 872"
          transform="translate(-24453 -23842)"
        >
          <rect width="10" height="21" rx="2" stroke="none" />
          <rect
            x="0.25"
            y="0.25"
            width="9.5"
            height="20.5"
            rx="1.75"
            fill="none"
          />
        </g>
      </g>
    </svg>
  );
}

export { SynthesisIcon };
